export const formatChannelLabel = channel =>
  channel.name + (channel.description ? ` - ${channel.description}` : '');

/** Admin-only picker rows must set canAdmin so TableField role controls stay enabled. */
export const mapChannelPickerOption = channel => {
  const label = formatChannelLabel(channel);
  return {
    label,
    value: {
      id: channel._id,
      name: label,
      canAdmin: true,
    },
  };
};
